var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.inline ? 'code' : 'pre',{tag:"component",staticClass:"ds-code",class:[
    _vm.inline && "ds-code-inline"
  ]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }